// removed by extract-text-webpack-plugin
module.exports = {"noBorder":"_20z1tX2u-nX3Wg6YEwVMhm"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OasisYourOrderExceedsMaxTotalForToken.scss
// module id = 1261
// module chunks = 0